export default {
	TABLE_TITLE: 'Currencies',
	POS_CONFIGURATION_VERSION_CURRENCY_ADDED:
		'POS configuration version currency added',
	POS_CONFIGURATION_VERSION_CURRENCY_EDITED:
		'POS configuration version currency edited',
	POS_CONFIGURATION_VERSION_CURRENCY_DELETED:
		'POS configuration version currency deleted',
};
